export default window.self !== window.top;



// WEBPACK FOOTER //
// ./src/utils/isIframe.js